import BootImageModal from "./boot-image-modal.component";

export default BootImageModal;
